import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from './pages/landingPage';
import ProjectsPage from "./pages/projectsPage";
import AboutMePage from "./pages/aboutMePage";
import ContactPage from "./pages/contactPage";
import WildSidePage from "./pages/wildSidePage";
import SideNav from './components/sideNav';
import './App.css';

const App = () => {
    return (
        <div>
            <Router>
                <SideNav />
                <Routes>
                    {/* Main Pages */}
                    <Route exact path="/" Component={LandingPage} />
                    <Route path="/projects" Component={ProjectsPage} />
                    <Route path="/about" Component={AboutMePage} />
                    <Route path="/contact" Component={ContactPage} />
                    <Route path="/wildside" Component={WildSidePage} />
                </Routes>
            </Router>
        </div>
    );
};

export default App;
